var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.668 20.72h2.44l5.386-6.396 1.557 1.767h-1.893l-1.094 1.263h4.04l1.304 1.515h2.524l2.105-1.851 2.146 1.851H31L21.7 11H18.8l5.764 4.88-1.85 1.473-3.914-4.46h-2.482l-5.066 5.963 2.204-5.836h-2.02L9.92 17.017 8.363 13.02H5.797l-1.389 3.997-1.515-3.997H1l2.104 6.017h2.693l1.346-3.872 1.43 3.872h2.524l-1.43 1.682zm18.513-5.386-1.556-1.01 1.557-1.43H31l-2.82 2.44z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaxp);
export default __webpack_public_path__ + "static/media/WAXP.daa284692018d5d898b8fa7203fc30d4.svg";
export { ForwardRef as ReactComponent };